import {all, takeLatest, takeEvery} from 'redux-saga/effects';
import {handleUserLogin, handleUserLogout} from './handlers/login';
import {
  handleGetAllItems,
  handleAddItems,
  handleDeleteItems,
  handleGetSelectedItems,
  handleTransferItems,
  handleBulkUpdateItems,
  handleGetDynamicUiPages, handleAddOrUpdateDynamicUiPage, handleDeleteDynamicUiPage, handleGetSection
} from './handlers/dynamicUi';
import {loginUser, tryUserLogout} from '../slices/loginSlice';
import {handleRemoveImage, handleUploadImage} from './handlers/imageUploadHandler';
import {removeImage, uploadImage} from '../slices/imageUploadSlice';
import {handleGetNotificationReport} from './handlers/notificationHandler';
import {fetchConsultationList} from '../slices/consultationSlice';
import {handleFetchConsultation} from './handlers/consultationHandler';
import {
  fetchPromoEventList,
  togglePromoEventStatus,
  createPromoEvent,
  fetchEventDoctorAssociation,
  associateEventDoctor
} from '../slices/promoEventSlice';
import {
  handleFetchPromoEvents,
  handleTogglePromoEventStatus,
  handleCreatePromoEvent,
  handleFetchEventDoctorAssociation,
  handleEventDoctorAssociation
} from './handlers/promoEventHandler';
import {createPharmacist, fetchPharmacistList, filterPharmacists} from '../slices/pharmacistSlice';
import {handleCreatePharmacist, handleFetchPharmacists, handleFilterPharmacist} from './handlers/pharmacistHandler';
import {
  createFocusItem,
  deleteFocusItem,
  fetchFocusItemList,
  updateFocusItem,
  tryFetchFocusItem
} from '../slices/focusItemsSlice';
import {
  handleCreateFocusItem,
  handleDeleteFocusItem,
  handleFetchFocusItem,
  handleFetchFocusItems, handleGetBundleTimers,
  handleUpdateFocusItem, handleUpdateTimerItem
}
  from
    './handlers/focusItemsHandler';
import {searchPaymentList, verifyPayment} from '../slices/paymentVerificationSlice';
import {handlePaymentSearch, handlePaymentVerification} from './handlers/paymentVerficationHandler';
import {fetchRemoteConfig, updateRemoteConfig} from '../slices/remoteConfigSlice';
import {handleGetRemoteConfig, handleUpdateRemoteConfig} from './handlers/remoteConfigHandler';
import {
  getAllItems,
  addItems,
  deleteItem,
  getSelectedItems,
  transferItem,
  bulkUpdateItems,
  tryGetDynamicUiPages,
  tryAddOrUpdateDynamicUiPage,
  tryDeleteDynamicUiPage,
  trySearchFocusItemSection,
  tryAddOrUpdatePageTab, tryRemovePageTab, tryChangePageSettings,
} from '../slices/dynamicUiSlice'
import {
  loadFocusedItems,
  loadSpecialBrands,
  tryGetAllBannerTypes,
  tryGetPredictionCampaign,
  tryGetPredictionCategories,
  tryGetProductCampaign,
  tryLoadFocusItems, tryLoadInitialSearchData
} from '../slices/searchSlice';
import {
  handleFetchProductCampaign,
  handleLoadBannerTypes,
  handleLoadBrandCampaign,
  handleLoadFocusedItems, handleLoadInitialSearchData, handleLoadPredictionCampaign, handleLoadPredictionCategories, handleSearchFocusedItems
} from './handlers/search';
import {
  loadAllBrands, loadBundleTimers,
  loadCampaigns,
  loadCarousel, loadPromotionalEvents,
  loadRemoteConfigs,
  loadWeeklyBrands, tryUpdateBundleTimerItem
} from '../slices/dynamicElementsSlice';
import {
  handleGetBrandList,
  handleGetBrandWeekList, handleGetCampaigns,
  handleGetCarousel, handleGetPromotionalEvents,
  handleGetRemoteConfigs
} from './handlers/dynamicElements';
import {
  loadBrandDayInfo,
  loadBrandMonthList, loadFlashSaleList,
  loadFocusedItem, loadFreshSpecialList,
  loadHotSpecialList, loadProductListByValueAndType,
  loadDynamicBanner,
  loadFeaturedList,
  loadPrediction
} from "../slices/dynamicMultipleElementsSlice";
import {handleGetBrandDayInfo, handleGetBrandMonthList, handleGetFocusedItem, handleGetPredictionCampaign} from "./handlers/dynamicMultipleElements";
import {
    handleGetFeaturedList,
  handleGetFlashSaleList,
  handleGetFreshSpecialList,
  handleGetHotSpecialList,
  handleGetProductList
} from "./handlers/products";
import {
  handleGetBanners
} from "./handlers/bannerHandler";
import {
  handleAddCommunities,
  handleAddEducation,
  handleAddExperience,
  handleAddSpecializationSet,
  handleCommunitiesGet,
  handleDeleteCommunity, handleDeleteEducation,
  handleDeleteExperience,
  handleDeleteSpeciality,
  handleDoctorInfoGet,
  handleDoctorSearch,
  handleEditDoctorProfile,
  handleSpecialitiesGet,
  handleUpdateEducation,
  handleUpdateExperience,
  handleVerifyNmc
} from "./handlers/doctor";
import {
  addEducations,
  addExperiences,
  deleteCommunity, deleteEducation,
  deleteExperience,
  deleteSpeciality,
  editCommunities, editDoctorProfile,
  editSpecialization, getCommunities,
  getDoctorInfo,
  getDoctorList,
  getSpecialities,
  updateEducation,
  updateExperience,
  verifyNmc
} from "../slices/doctorSlice";
import {createUser, getDeliveryUsers, setChangeStatus} from "../slices/deliverySlice";
import {handleChangeStatus, handleCreateDeliveryUser, handleGetDeliveryUser} from "./handlers/delivery";
import {createNurse, getNurse, setChangeNurseStatus} from "../slices/nurseSlice";
import {handleChangeNurseStatus, handleCreateNurse, handleGetNurse} from "./handlers/nurseHandler";
import {getClinicInfo, getClinics, setClinicStatus} from "../slices/businessSlice";
import {
  handleGetClinicInfo,
  handleGetClinics,
  handleSetClinicStatus
} from "./handlers/business";
import {fetchCampaignReports} from "../slices/campaignReportingSlice";
import {handleFetchCampaignReports} from "./handlers/campaignReportingHandler";
import {getWishlist} from "../slices/wishlistSlice";
import {handleGetWishlist} from "./handlers/wishlist";
import nurseCampaignSaga from './nurseCampaignSaga';
import campaignShiftSaga from './saga/shiftSaga';
import locationSaga from "./locationSaga";
import prescriptionSaga from './saga/prescriptionSaga';
import {tryFetchCitiesAndAreas, tryFetchProvinces, tryPostNewAddress} from "../slices/addressSlice";
import {handleAddAddress, handleGetCitiesAndAreas, handleGetProvinces} from "./handlers/addressHandler";
import bannerSaga from './saga/bannerSaga';
import { getCartReportListing } from 'redux/slices/cartReportingSlice';
import { handleGetCartReportlist } from './handlers/cartHandler';
import notificationSaga from './notificationSaga';
import { tryFetchNotificationReport } from 'redux/slices/notificationReportSlice';
import { tryGetFaqById , tryUpdateFaq, tryCreateFaq} from 'redux/slices/faqSlice';
import { handleAddFaq, handleGetFaq, handleUpdateFaq, handleCreateFaq, handleRemoveFaq } from './handlers/faqHandler';
import { tryAddFaq } from 'redux/slices/faqSlice';
import { tryRemoveFaq } from 'redux/slices/faqSlice';
import predictionSaga from './saga/predictionSaga';
import {
  tryAddOrUpdateUsers,
  tryChangeUsersPassword,
  tryLoadUsers,
  tryUpdateUserFeatures,
  tryUpdateUsersState
} from "../slices/manageUserSlice";
import {
  handleAddOrUpdateAdminUsers,
  handleGetAdminUsers,
  handleGetUsersProfile, handleUpdateUserFeatures, handleUpdateUsersPassword,
  handleUpdateUsersState
} from "./handlers/users";
import {tryGetUsersProfile} from "../slices/authTokenSlice";
import {
  tryAddOrUpdateFeature,
  tryDeleteFeature,
  tryLoadFeatures,
  tryLoadPermissions,
  tryUpdateFeaturesPermissions
} from "../slices/permissionSlice";
import {
  handleAddOrUpdateFeature,
  handleDeleteFeature,
  handleGetAllFeatures,
  handleGetAllPermissions, handleUpdateFeaturesPermissions
} from "./handlers/permissions";
import {
  tryAddNewBlog, tryAddNewTagAndUpdateInBlog,
  tryAddOrUpdateBlogTags,
  tryDeleteBlogTag, tryLoadBlogDetail,
  tryLoadBlogs, tryLoadTags,
  tryUpdateBlogContents
} from "../slices/manageBlogSlice";
import {
  handleAddNewBlog,
  handleAddOrUpdateBlogTags, handleAddTagsAndUpdateInBlog,
  handleDeleteBlogTag, handleGetBlogDetail,
  handleGetBlogs,
  handleUpdateBlogContents
} from "./handlers/blogs";
import {
  handleFetchCustomerBalance,
  handleFetchCustomerTransactions,
} from './handlers/rewardLoyaltyHandler'
import {
  handleCalculatePoints,
  handleCalculateCash,
  handleCalculateEncashment,
  handleValidateRedemption,
} from './handlers/rewardCalculatorHandler'
import {
  handleFetchUsers,
  handleFetchUserById,
  handleCreateUser,
  handleUpdateUser,
} from './handlers/rewardUsersHandler'
import {
  handleFetchPoints,
  handleFetchPointById,
  handleCreatePoint,
  handleCancelPoint,
  handleFetchUserBalance,
  handleFetchUserPoints,
  handleSetMaturity,
  handleBatchPost,
  handleBatchCancel,
  handleCalculate,
} from './handlers/rewardPointsHandler'
import {
  tryFetchCustomerBalance,
  tryFetchCustomerTransactions,
} from '../slices/rewardLoyaltySlice'
import {
  tryCalculatePoints,
  tryCalculateCash,
  tryCalculateEncashment,
  tryValidateRedemption,
} from '../slices/rewardCalculatorSlice'
import {
  tryFetchUsers,
  tryFetchUserById,
  tryCreateUser,
  tryUpdateUser,
} from '../slices/rewardUsersSlice'
import {
  tryFetchPoints,
  tryFetchPointById,
  tryCreatePoint,
  tryCancelPoint,
  tryFetchUserBalance,
  tryFetchUserPoints,
  trySetMaturity,
  tryBatchPost,
  tryBatchCancel,
  tryCalculate,
} from '../slices/rewardPointsSlice'
import {
  handleAddOrUpdatePageTabs,
  handleChangePageSettings,
  handleRemovePageTab,
} from './handlers/pageTabs'
import { handleGenerateLinks } from './handlers/dashboard'
import { tryGenerateLinks } from '../slices/dashboardSlice'
import fulfillmentOperatorSaga from './saga/fulfillmentOperatorSaga';


export function* watcherSaga() {
  yield all(
    [
      takeLatest(loginUser.type, handleUserLogin),
      takeLatest(tryUserLogout.type, handleUserLogout),
      takeLatest(getDeliveryUsers.type, handleGetDeliveryUser),
      takeLatest(createUser.type, handleCreateDeliveryUser),
      takeLatest(setChangeStatus.type, handleChangeStatus),
      takeLatest(uploadImage.type, handleUploadImage),
      takeLatest(removeImage.type, handleRemoveImage),
      takeLatest(fetchConsultationList.type, handleFetchConsultation),
      takeLatest(fetchPromoEventList.type, handleFetchPromoEvents),
      takeLatest(togglePromoEventStatus.type, handleTogglePromoEventStatus),
      takeLatest(createPromoEvent.type, handleCreatePromoEvent),
      takeLatest(fetchPharmacistList.type, handleFetchPharmacists),
      takeLatest(createPharmacist.type, handleCreatePharmacist),
      takeLatest(filterPharmacists.type, handleFilterPharmacist),
      takeLatest(fetchFocusItemList.type, handleFetchFocusItems),
      takeLatest(createFocusItem.type, handleCreateFocusItem),
      takeLatest(deleteFocusItem.type, handleDeleteFocusItem),
      takeLatest(updateFocusItem.type, handleUpdateFocusItem),
      takeLatest(tryFetchFocusItem.type, handleFetchFocusItem),
      takeLatest(tryLoadFocusItems.type, handleSearchFocusedItems),
      takeEvery(tryLoadInitialSearchData.type, handleLoadInitialSearchData),
      takeLatest(searchPaymentList.type, handlePaymentSearch),
      takeLatest(verifyPayment.type, handlePaymentVerification),
      takeLatest(fetchRemoteConfig.type, handleGetRemoteConfig),
      takeLatest(updateRemoteConfig.type, handleUpdateRemoteConfig),
      takeLatest(getAllItems.type, handleGetAllItems),
      takeLatest(loadSpecialBrands.type, handleLoadBrandCampaign),
      takeLatest(addItems.type, handleAddItems),
      takeLatest(loadBundleTimers.type, handleGetBundleTimers),
      takeLatest(tryUpdateBundleTimerItem.type, handleUpdateTimerItem),

      takeLatest(loadFocusedItems.type, handleLoadFocusedItems),
      takeLatest(tryGetAllBannerTypes.type, handleLoadBannerTypes),
      takeLatest(deleteItem.type, handleDeleteItems),


      takeEvery(tryGetPredictionCampaign.type, handleLoadPredictionCampaign),
      takeEvery(tryGetPredictionCategories.type, handleLoadPredictionCategories),
      takeEvery(loadFocusedItem.type, handleGetFocusedItem),
      takeEvery(loadBrandDayInfo.type, handleGetBrandDayInfo),
      takeEvery(loadBrandMonthList.type, handleGetBrandMonthList),
      takeEvery(loadProductListByValueAndType.type, handleGetProductList),
      takeLatest(loadWeeklyBrands.type, handleGetBrandWeekList),
      takeEvery(loadAllBrands.type, handleGetBrandList),
      takeLatest(loadCarousel.type, handleGetCarousel),
      takeEvery(loadDynamicBanner.type, handleGetBanners),
      takeEvery(loadPrediction.type, handleGetPredictionCampaign),
      takeLatest(loadRemoteConfigs.type, handleGetRemoteConfigs),
      takeLatest(loadCampaigns.type, handleGetCampaigns),
      takeLatest(loadPromotionalEvents.type, handleGetPromotionalEvents),
      takeLatest(loadHotSpecialList.type, handleGetHotSpecialList),
      takeLatest(loadFreshSpecialList.type, handleGetFreshSpecialList),
      takeLatest(loadFeaturedList.type, handleGetFeaturedList),
      takeLatest(loadFlashSaleList.type, handleGetFlashSaleList),
      takeLatest(getSpecialities.type, handleSpecialitiesGet),
      takeLatest(getDoctorList.type, handleDoctorSearch),
      takeLatest(getDoctorInfo.type, handleDoctorInfoGet),
      takeLatest(getCommunities.type, handleCommunitiesGet),
      takeLatest(editDoctorProfile.type, handleEditDoctorProfile),
      takeLatest(editCommunities.type, handleAddCommunities),
      takeLatest(editSpecialization.type, handleAddSpecializationSet),
      takeLatest(deleteCommunity.type, handleDeleteCommunity),
      takeLatest(deleteSpeciality.type, handleDeleteSpeciality),
      takeLatest(addEducations.type, handleAddEducation),
      takeLatest(addExperiences.type, handleAddExperience),
      takeLatest(deleteExperience.type, handleDeleteExperience),
      takeLatest(deleteEducation.type, handleDeleteEducation),
      takeLatest(updateEducation.type, handleUpdateEducation),
      takeLatest(updateExperience.type, handleUpdateExperience),
      takeLatest(verifyNmc.type, handleVerifyNmc),
      takeLatest(getNurse.type, handleGetNurse),
      takeLatest(createNurse.type, handleCreateNurse),
      takeLatest(setChangeNurseStatus.type, handleChangeNurseStatus),
      takeLatest(fetchEventDoctorAssociation.type, handleFetchEventDoctorAssociation),
      takeLatest(associateEventDoctor, handleEventDoctorAssociation),
      takeLatest(getClinics.type, handleGetClinics),
      takeLatest(setClinicStatus.type, handleSetClinicStatus),
      takeLatest(getClinicInfo.type, handleGetClinicInfo),
      takeLatest(fetchCampaignReports.type, handleFetchCampaignReports),
      takeLatest(getWishlist.type, handleGetWishlist),
      takeLatest(getCartReportListing.type, handleGetCartReportlist),
      takeLatest(trySearchFocusItemSection.type, handleGetSection),
      ...nurseCampaignSaga,
      ...campaignShiftSaga,
      ...locationSaga,
      ...prescriptionSaga,
      addressSaga(),
      productCampaign(),
      ...bannerSaga,
      dynamicUiSaga(),
      ...notificationSaga,
      notificationReportSaga(),
      faqSaga(),
      manageBlogsSaga(),
      ...predictionSaga,
      manageUserSaga(),
      ...rewardSaga(),
      dashboardSaga(),
      ...fulfillmentOperatorSaga,
    ]
  )
}

export function* addressSaga() {
  yield takeLatest(tryFetchProvinces.type, handleGetProvinces);
  yield takeEvery(tryFetchCitiesAndAreas.type, handleGetCitiesAndAreas);
  yield takeLatest(tryPostNewAddress.type, handleAddAddress);
}

export function* dashboardSaga() {
  yield takeLatest(tryGenerateLinks.type, handleGenerateLinks);
}

export function* dynamicUiSaga() {
  yield takeLatest(tryGetDynamicUiPages.type, handleGetDynamicUiPages);
  yield takeLatest(tryAddOrUpdateDynamicUiPage, handleAddOrUpdateDynamicUiPage);
  yield takeLatest(tryDeleteDynamicUiPage, handleDeleteDynamicUiPage);
  yield takeLatest(getSelectedItems.type, handleGetSelectedItems);
  yield takeLatest(transferItem.type, handleTransferItems);
  yield takeLatest(bulkUpdateItems.type, handleBulkUpdateItems);

  yield takeLatest(tryAddOrUpdatePageTab.type, handleAddOrUpdatePageTabs);
  yield takeLatest(tryRemovePageTab.type, handleRemovePageTab);
  yield takeLatest(tryChangePageSettings.type, handleChangePageSettings);
}

export function* productCampaign() {
  yield takeEvery(tryGetProductCampaign.type, handleFetchProductCampaign);
  yield takeLatest(tryGetProductCampaign.type, handleFetchProductCampaign);
}

export function* notificationReportSaga() {
  yield takeLatest(tryFetchNotificationReport.type, handleGetNotificationReport);
}

export function* faqSaga(){
  yield takeLatest(tryGetFaqById.type, handleGetFaq);
  yield takeLatest(tryUpdateFaq.type, handleUpdateFaq);
  yield takeLatest(tryCreateFaq.type, handleCreateFaq);
  yield takeLatest(tryAddFaq.type, handleAddFaq);
  yield takeLatest(tryRemoveFaq.type, handleRemoveFaq);
}

export function* manageUserSaga() {
  yield takeLatest(tryLoadUsers.type, handleGetAdminUsers);
  yield takeLatest(tryAddOrUpdateUsers.type, handleAddOrUpdateAdminUsers);
  yield takeLatest(tryUpdateUsersState.type, handleUpdateUsersState);
  yield takeLatest(tryGetUsersProfile.type, handleGetUsersProfile);
  yield takeLatest(tryUpdateUserFeatures.type, handleUpdateUserFeatures);
  yield takeLatest(tryChangeUsersPassword.type, handleUpdateUsersPassword);


  yield takeLatest(tryLoadFeatures.type, handleGetAllFeatures);
  yield takeLatest(tryLoadPermissions.type, handleGetAllPermissions);
  yield takeLatest(tryAddOrUpdateFeature.type, handleAddOrUpdateFeature);
  yield takeLatest(tryDeleteFeature.type, handleDeleteFeature);
  yield takeLatest(tryUpdateFeaturesPermissions.type, handleUpdateFeaturesPermissions);
}

export function* manageBlogsSaga() {
  yield takeEvery(tryLoadBlogs.type, handleGetBlogs);
  yield takeEvery(tryLoadTags.type, handleGetBlogs);
  yield takeLatest(tryAddOrUpdateBlogTags.type, handleAddOrUpdateBlogTags);
  yield takeLatest(tryDeleteBlogTag.type, handleDeleteBlogTag);
  yield takeLatest(tryAddNewBlog.type, handleAddNewBlog);
  yield takeLatest(tryUpdateBlogContents.type, handleUpdateBlogContents);
  yield takeLatest(tryLoadBlogDetail.type, handleGetBlogDetail);
  yield takeLatest(tryAddNewTagAndUpdateInBlog.type, handleAddTagsAndUpdateInBlog);
}

export function* rewardSaga() {
  yield takeLatest(tryFetchCustomerBalance.type, handleFetchCustomerBalance);
  yield takeLatest(tryFetchCustomerTransactions.type, handleFetchCustomerTransactions);

  yield takeLatest(tryCalculatePoints.type, handleCalculatePoints);
  yield takeLatest(tryCalculateCash.type, handleCalculateCash);
  yield takeLatest(tryCalculateEncashment.type, handleCalculateEncashment);
  yield takeLatest(tryValidateRedemption.type, handleValidateRedemption);

  yield takeLatest(tryFetchUsers.type, handleFetchUsers);
  yield takeLatest(tryFetchUserById.type, handleFetchUserById);
  yield takeLatest(tryCreateUser.type, handleCreateUser);
  yield takeLatest(tryUpdateUser.type, handleUpdateUser);

   yield takeLatest(tryFetchPoints.type, handleFetchPoints);
   yield takeLatest(tryFetchPointById.type, handleFetchPointById);
   yield takeLatest(tryCreatePoint.type, handleCreatePoint);
   yield takeLatest(tryCancelPoint.type, handleCancelPoint);
   yield takeLatest(tryFetchUserBalance.type, handleFetchUserBalance);
   yield takeLatest(tryFetchUserPoints.type, handleFetchUserPoints);
   yield takeLatest(trySetMaturity.type, handleSetMaturity);
   yield takeLatest(tryBatchPost.type, handleBatchPost);
   yield takeLatest(tryBatchCancel.type, handleBatchCancel);
   yield takeLatest(tryCalculate.type, handleCalculate);
}
